export default class EditController {
  constructor(ImagesDataProvider, $state) {
    "ngInject"
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    let
      vm = this;
    vm.ImagesDataProvider.getCategoryById(vm.$state.params.id).then(function (result) {
      vm.category = result;
    });
  }

  update(form) {
    if (!form) {
      return false;
    }
    let
      vm = this;
    vm.ImagesDataProvider.updateCategory(vm.category).then(function (res) {
      if (res.exist == '1') {
        vm.existRecord = 1;
      }
      else {
        vm.$state.go('app.imageCategories');
      }
    })

  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/category_edit/controller.js
 **/